import { getCustomUTCDate } from "src/utils/get-date";

// ----------------------------------------------------------------------

export function getRequestBody(request) {
    if (!request) return undefined;

    const _request = JSON.parse(JSON.stringify(request));

    if (_request.source_type && _request.source_type === "all") {
        delete _request.source_type;
    }

    if (_request.keyword) {
        _request.tracking_number = _request.keyword;
    }

    if (_request?.start_day) {
        _request.start_day = getCustomUTCDate(_request.start_day);
    }

    if (_request?.end_day) {
        _request.end_day = getCustomUTCDate(_request.end_day);
    }

    delete _request.total;
    delete _request.keyword;

    return _request;
}
